var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDummyProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 3.5,
    stroke: "#464E5F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1374_58)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 26,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#464E5F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 47,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#464E5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1374_58"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyProfile);
export default __webpack_public_path__ + "static/media/dummyProfile.a5c346d7c2cc47673d0b900f3ec1f54a.svg";
export { ForwardRef as ReactComponent };